import React from 'react';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useTranslation } from "react-i18next";
// function rand() {
//   return Math.round(Math.random() * 20) - 10;
// }

// function getModalStyle() {
//   const top = 50 + rand();
//   const left = 50 + rand();

//   return {
//     left: `${50}%`,
//     transform: `translate(-${50}%, ${0}%)`,
//   };
// }

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 1050,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: '50%',
    left: '50%',
    transform: `translate(-${50}%, -${50}%)`,
  },
}));

export default function Modalvacio(props) {
  const { urlimg } = props;
  const { t } = useTranslation("common");
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  // const [modalStyle] = React.useState(getModalStyle);
  const handleOpen = () => {           
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const body = (
    <div className={classes.paper}>
      <TransformWrapper >
        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
          <React.Fragment>
            <div className="tools">
              <button onClick={() => zoomIn()}>
              <i className="fa fa-search-plus"></i>
              </button> 
              <button onClick={() => zoomOut()}>
              <i className="fa fa-search-minus"></i>
              </button>
            </div>
            <TransformComponent>
              <img
                src={urlimg}
                alt=" img "
                style={{ width :"100%"}}
              />
            </TransformComponent>
          </React.Fragment>
        )}
      </TransformWrapper>
    </div>
  );

  return (
    <div>
      <button type="button" onClick={handleOpen} 
      className ="lock bg-yellow-300 border border-yellow-500 px-10 py-3 font-bold rounded shadow hover:bg-yellow-400 text-yellow-800">
        {t("modal.show_img")}
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className="w-full h-full"
      >
        {body}
      </Modal>
    </div>
  );
}
